import { Box, styled } from '@mui/material';

/** 레거시 마크업 class 보충 */
export const FncoPriceSupplyRoot = styled(Box)`
  /* 공통 표의 break-all 보다 우선해야 영문 머리글이 단어 중간에서 안 끊김 */
  & .approval-form-table th {
    word-break: keep-all;
  }
  & th.text-right,
  & td.text-right {
    text-align: right;
  }
  & p {
    margin: 8px 0 0;
  }
  & .text-muted {
    font-size: 13px;
    color: var(--dk-text-sub, #6b7280);
  }
`;
